<template>
  <IModal v-model="isShow">
    <div :class="$style.wrapper">
      <svg width="90" height="67" viewBox="0 0 90 67" fill="none" xmlns="http://www.w3.org/2000/svg" :class="$style.icon">
        <path
          d="M86.4844 0H3.51596C2.53194 0 1.63194 0.418667 1.01319 1.04754C0.394437 1.66192 0.000335335 2.54168 0.000335335 3.50542V63.4946C-0.0133756 64.4447 0.394437 65.3379 1.0269 65.9668C1.64565 66.5949 2.54582 67 3.51596 67H86.4844C87.441 67 88.341 66.5949 88.9734 65.9668C89.6066 65.3379 90 64.4447 90 63.4946V3.50542C90 2.54168 89.6066 1.66192 88.9734 1.04754C88.3549 0.418667 87.4545 0 86.4844 0ZM84.6984 9.39644V61.7344H5.28819V9.37182L40.4863 40.5185H40.5007C41.7661 41.6362 43.3832 42.2229 44.9866 42.2229C45.549 42.2229 46.0976 42.1247 46.6455 41.9854H46.8146L47.2368 41.8314C48.0519 41.5524 48.8115 41.1051 49.4863 40.5187C55.4562 35.2421 69.8667 22.4923 79.5586 13.919L84.6984 9.39644ZM81.3565 5.28624C72.711 12.9361 53.1787 30.2163 45.9705 36.5936C45.816 36.7196 45.647 36.8174 45.4788 36.8733C45.3236 36.9291 45.1554 36.9572 44.9865 36.9572C44.6349 36.9572 44.297 36.8453 44.0017 36.5799L8.60676 5.26564H50.3163L81.3565 5.28624Z"
          fill="#C6937A"
        />
      </svg>
      <h3 :class="$style.title">会員登録が完了しておりません</h3>
      <p :class="$style.lead">ご登録のメールアドレス宛てに「アドレス認証メール」をお送りしております。メールの案内に従い、認証を完了させてください。</p>
      <p><a href="" target="_blank" :class="$style.link" @click.prevent="onClickSendButton">認証メールを再送する</a></p>
    </div>
  </IModal>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { confirmEmail } from '@/js/lib/api/account/your/account';
import { info, loading } from '@/js/lib/ui';
import IModal from '@/js/components/molecules/IModal.vue';

const isShow = ref(true);
const onClickSendButton = () => {
  isShow.value = false;
  loading({
    asyncFunc: async () => {
      try {
        await confirmEmail({ next: window.location.href });
        info('認証メールを送信いたしました\nメールの案内に従いメールアドレス認証を完了させてください。');
      } catch (error) {
        info(error.message || 'メールを送信できませんでした。\nお手数ですが、ブラウザを再読み込みして再度お試しください。');
      }
    },
  });
};
</script>

<style module lang="scss">
.wrapper {
  background-color: var(--color-white);
  line-height: 1.5;
  padding: 20px 0 0;
  text-align: center;
}

.icon {
  @media (--sp) {
    height: auto;
    width: 70px;
  }
}

.title {
  font-size: 24px;
  font-weight: bold;
  margin: 20px 0;

  @media (--sp) {
    font-size: 18px;
  }
}

.lead {
  font-size: 16px;
  margin: 0 0 15px;
  text-align: left;
}

.link {
  font-size: 16px;
  text-decoration: underline;
}
</style>
